module.exports = __webpack_public_path__ + "static/bueno-mano-1427a4073d15ae3b701bc73d5c2faa63.jpg";